import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAdmin: false,
  isSubscriber: false,
  isVisitor: false,
  isAuthLoading: true, 
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthStatus: (state, action) => {
      state.isAdmin = action.payload.isAdmin;
      state.isSubscriber = action.payload.isSubscriber;
      state.isVisitor = action.payload.isVisitor;
      state.isAuthLoading = false; 
    },
    clearAuthStatus: (state) => {
      state.isAdmin = false;
      state.isSubscriber = false;
      state.isVisitor = false;
      state.isAuthLoading = false; 
    },
  },
});

export const { setAuthStatus, clearAuthStatus } = authSlice.actions;
export default authSlice.reducer;
